import type { App } from "vue";
import { createPinia } from "pinia";

/**
 * Installs Pinia on the provided app.
 *
 * @param app The app to install Pinia on.
 * @returns The app with Pinia installed.
 */
export default function installPinia(app: App) {
  const pinia = createPinia();
  return app.use(pinia);
}
